// External script provided by a third party
import initESW from './EnhancedChatScript';

const SalesForceChat = () => ({
  showChatWindow(language) {
    window?.embeddedservice_bootstrap?.utilAPI?.removeAllComponents();
    // eslint-disable-next-line no-undef
    const { REACT_APP_SALESFORCE_ENHANCED_ID, REACT_APP_SALESFORCE_ENHANCED_SERVICE } = process.env;
    if (!Array.from(document.scripts).some((s) => s.src && s.src.includes(REACT_APP_SALESFORCE_ENHANCED_ID))) {
      const s = document.createElement('script');
      s.setAttribute('src', REACT_APP_SALESFORCE_ENHANCED_SERVICE);
      s.onload = () => {
        initESW(language);
        setTimeout(() => {
          window.embeddedservice_bootstrap.bootstrapEmbeddedMessaging();
        }, 2000);
      };

      document.body.appendChild(s);
    } else {
      initESW(language);
      setTimeout(() => {
        window.embeddedservice_bootstrap.bootstrapEmbeddedMessaging();
      }, 2000);
    }
  },
});

export default SalesForceChat;
